function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ImageCropper from '../../imageCropper/ImageCropper';
import { calculateWidthToPreventAncestorScroll, pickPropsByTypes } from '../utils';
/**
 * This component is needed to handle a complex layout concern.
 * The cropper is built to take up the maximum amount of horizontal space possible.
 * This allows us to use it with our grid to manage responsiveness and constrain size.
 * Unfortunately, with portrait images (especially if they are very tall) this
 * causes it to overflow the vertical height available and a scrollbar appears.
 * This isn't ideal and makes it hard to use.
 * Ideally, we'd use CSS `object-fit: contain` to achieve the desired behavior but
 * due to the complex nature of the croppers layout and functional requirements,
 * this is not feasible.
 * This component introduces manual width handling based on the available height to
 * mimic the behavior of `object-fit: contain` in a way that works with the cropper.
 *
 * Please don't reuse this methodology without consulting with Frontend-foundry first
 * to seek a more optimized, standardized, and universal solution.
 */

var ConstrainedHeightCropper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ConstrainedHeightCropper, _React$Component);

  function ConstrainedHeightCropper() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ConstrainedHeightCropper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ConstrainedHeightCropper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      width: undefined
    });

    return _this;
  }

  _createClass(ConstrainedHeightCropper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._explicitlySetWidth();
    }
  }, {
    key: "_setRef",
    value: function _setRef(node) {
      this._container = node;
    }
  }, {
    key: "_explicitlySetWidth",
    value: function _explicitlySetWidth() {
      var width = this.state.width;
      var newWidth = calculateWidthToPreventAncestorScroll(this._container);

      if (newWidth && newWidth !== width) {
        this.setState({
          width: newWidth
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var cropperProps = pickPropsByTypes(this.props, ImageCropper.propTypes);
      var width = this.state.width;
      var styles;

      if (width) {
        styles = {
          width: width
        };
      }

      return React.createElement("div", {
        ref: this._setRef.bind(this),
        style: styles,
        className: "cropper-image-center"
      }, React.createElement(ImageCropper, cropperProps));
    }
  }]);

  return ConstrainedHeightCropper;
}(React.Component);

_defineProperty(ConstrainedHeightCropper, "propTypes", _objectSpread({}, ImageCropper.propTypes));

export { ConstrainedHeightCropper as default };